import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints } from '../../api/Constants';
import RequestHelper from '../../api/RequestHelper';
export var getProgressiveJackpots = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var progressiveJackpotsResponse;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return RequestHelper.apiGet({
              endpoint: Endpoints.PROGRESSIVE_JACKPOTS,
              shouldSkipIsConnectedCheck: true
            });

          case 2:
            progressiveJackpotsResponse = _context.sent;
            return _context.abrupt("return", progressiveJackpotsResponse);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getProgressiveJackpots() {
    return _ref.apply(this, arguments);
  };
}();